import React from "react";
import "./OnlineExam.css";

const OnlineExamHead = () => {
  return (
    <div className="onlineExamHead">
      <h2>
        Online <span>German Exam</span> Preparation
      </h2>
      <p>
        Prepare thoroughly for the Certification exam. These courses cover all
        four areas of the examination: reading, writing, listening, and speaking
        (oral module).
      </p>
    </div>
  );
};

export default OnlineExamHead;
